import { AfterViewInit, Directive, ElementRef, Input } from '@angular/core';
import { StudyType } from '../../../models/study-type';

@Directive({
  selector: '[dashboardStudyTypeColor]',
})
export class StudyTypeColorDirective implements AfterViewInit {
  @Input() studyType: string;

  constructor(private element: ElementRef) {}

  ngAfterViewInit() {
    let color;

    switch (this.studyType) {
      case StudyType.TIIM: {
        color = '#009688';
        break;
      }
      case StudyType.CC: {
        color = '#423d6f';
        break;
      }
      default: {
        color = 'black';
      }
    }

    this.element.nativeElement.style.color = color;
  }
}
